<template>
  <v-hover v-slot="{ hover }">
    <v-card
        class="ma-4 pa-1"
        :width=" width? width: 340"
        :elevation="hover ? 12 : 2"
        :color="(type=='Danger')? color:'#FFFFFF'"
    >
        <v-list-item>
        <v-row
          justify="end"
        >
        <v-list-item-content 
        >
          <v-card-title :class="(type=='Danger') ? 'white--text':''" class="card-title ml-4 pa-0"> {{totalcount.toLocaleString('en-US')}} </v-card-title>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-card-subtitle
                v-bind="attrs"
                v-on="on"
                :class="(type=='Danger') ? 'white--text py-0':'py-0'"
              >{{ title | translate }} </v-card-subtitle>
            </template>
            <span>{{ description| translate }} </span>
          </v-tooltip>

              <v-list
                subheader
                two-line
                :color="(type=='Danger')? '#FFFFFF':'#FFFFFF'"
                v-if="details && hover ? details.length ? true:false:false "
              >
                <v-list-item class="ml-2" :class="(type=='Danger') ? 'white--text':''" v-for="(carddetails,index) in details" :key="index">
                    <v-list-item-content>
                        <v-list-item-subtitle :class="(type=='Danger') ? 'black--text':''"> <v-icon color="grey">mdi-file-document </v-icon> {{carddetails.item_name}}</v-list-item-subtitle>
                        <v-list-item-subtitle :class="(type=='Danger') ? 'black--text':''"> <v-icon color="grey">mdi-file-document-edit </v-icon> {{carddetails.temp_name}}</v-list-item-subtitle>
                        <v-list-item-subtitle :class="(type=='Danger') ? 'black--text':''"> <v-icon color="grey">mdi-calendar-alert </v-icon> <b>{{carddetails.day_until}}</b> <span class="font-weight-light" >{{'days overdue'| translate}} </span></v-list-item-subtitle>
                    </v-list-item-content>
                 </v-list-item>
                <v-btn small class="ml-6 white--text" :color="color" :to="'/inbox'" >{{ 'Jump to Inbox'| translate }}</v-btn>
              </v-list>
        </v-list-item-content>

      
          <v-icon class="card-image" :color="color"  v-if="type=='Users'"> mdi-account-circle </v-icon>
          <v-icon class="card-image" :color="color"  v-if="type=='Modules'"> mdi-book </v-icon>
          <v-icon class="card-image" :color="color"  v-if="type=='Subscribers'"> mdi-account-check </v-icon>
          <v-icon class="card-image" :color="color"  v-if="type=='Certificates'"> mdi-medal </v-icon>
          <v-icon class="card-image" :color="color"  v-if="type=='Groups'"> mdi-account-group-outline </v-icon>
          <v-icon class="card-image" :color="color"  v-if="type=='Documents'"> mdi-file</v-icon>
          <v-icon class="card-image" :color="color"  v-if="type=='Tasks'"> mdi-clipboard-list </v-icon>
          <v-icon class="card-image" :color="color"  v-if="type=='Equipments'">  mdi-factory </v-icon>
          <v-icon class="card-image" color="#FFFFFF"  v-if="type=='Danger'"> mdi-exclamation-thick </v-icon>
          <v-icon class="card-image" :color="color"  v-if="type=='CoursesSubscribed'">  mdi-sticker-check-outline </v-icon>
          <v-icon class="card-image" :color="color"  v-if="type=='CoursesActive'">  mdi-sticker-emoji </v-icon>
        </v-row>
      </v-list-item>

    </v-card>
  </v-hover>
</template>

<script>
export default {
  name: 'SimpleCard',
    props: {
        width:Number,
        type: String,
        title: String,
        description: String,
        totalcount: Number,
        color: String,
        details: Array,
    }
}
</script>

<style scoped>
.card-title{
    font-size: 30px;
}

.card-image{
    font-size: 60px;
}
</style>